const forgotPasswordActivate = {
  toastr: 'Senha alterada',
  toastr1: 'Senha foi alterada com sucesso'
};

export default forgotPasswordActivate;
